
export const cartupInitScript = (CARTUP_SPOTDY_KEY: string) => {
	return `SPOTDYLIBRARY.init(['${CARTUP_SPOTDY_KEY}'])`
};

export const icecatLiveScript = (PRIMARY_EAN: string) => {

	return ` IcecatLive.getDatasheet(
		{
		  'productstory': '#IcecatLive'
		},
		{
		  GTIN: '${PRIMARY_EAN}',   
		  UserName: 'MDMbeheer'
		}, 'nl')`
};

export const showMoreLessDescriptionScript = () => `
	$('#show_more_description, .shortContentShowDesc').on("click", ()=>{
		$("#product_longdescription, .longContentDataDiv").slideDown(300);
		$("#show_more_description, .shortContentShowDesc").hide();
		$("#show_less_description, .longContentHideDesc").show();
	});
	$('#show_less_description, .longContentHideDesc').on("click", ()=>{
		$("#product_longdescription, .longContentDataDiv, #show_less_description, .longContentHideDesc").hide();
		$("#show_more_description, .shortContentShowDesc").show();
	})
`;

export const PDPDescriptionScrollIntoView = `
		$('#show_less_description, .longContentHideDesc').on("click", ()=>{
			const productDetailsTab = document.getElementById("product-details-tab-0");
			if(productDetailsTab !== null)productDetailsTab.scrollIntoViewIfNeeded({ behavior: "auto", block: "center"});
		})
	`;

export const categoryIntroShowMoreScripts = () => {
	return `
		$('.categoryIntroTextReadMore').on("click", function(){
			$(".category-introduction-text").addClass("remove-nowrap");
			$(".categoryIntroTextContentDiv").addClass("categoryIntroTextContentDiv-column");
			$(".category-introduction-text").removeClass("category-text-inline");
			$('.categoryIntroTextReadMore').hide();
			$('.categoryIntroTextReadLess').show();			
		});  
		$('.categoryIntroTextReadLess').on("click", function(){
			$(".category-introduction-text").removeClass("remove-nowrap");
			$(".categoryIntroTextContentDiv").removeClass("categoryIntroTextContentDiv-column");
			$(".category-introduction-text").addClass("category-text-inline");
			$('.categoryIntroTextReadMore').show();
			$('.categoryIntroTextReadLess').hide();
		});`
}

export const flowboxScript = (FLOW_KEY: string, PAGETYPE: string, VALUE: string,) => {
	
	return `
	(function(d, id) {
    	if (!window.flowbox) { var f = function () { f.q.push(arguments); }; f.q = []; window.flowbox = f; }
    	if (d.getElementById(id)) {return;}
    	var s = d.createElement('script'), fjs = d.scripts[d.scripts.length - 1]; s.id = id; s.async = true;
    	s.src = 'https://connect.getflowbox.com/flowbox.js';
    	fjs.parentNode.insertBefore(s, fjs);
  	})(document, 'flowbox-js-embed');
  
	var flowBoxInit = {
		key: '${FLOW_KEY}',
		locale: 'nl-NL',
	}
		
	if('${PAGETYPE}' === ''){
		flowBoxInit["container"] = '#js-flowbox-flow';
	}

	if('${PAGETYPE}' === 'PDP'){
		flowBoxInit["container"] = '#js-flowbox-flow_dynamic_pdp';
		flowBoxInit["productid"] = '${VALUE}';
	}

	if('${PAGETYPE}' === 'PLP'){
		flowBoxInit["container"] = '#js-flowbox-flow';
		flowBoxInit["tags"] = '${VALUE}';
	}

	window.flowbox('init', flowBoxInit)`
};


export const bazaarVoiceCallBackInpScript = (inputObj:any) => {
	return `
		window.bvCallback = function (BV) {
			BV.pixel.trackTransaction(${inputObj});
		};
	`;
}


export const klarnaRefreshExpressButton = () => {
	return `
		Klarna.ExpressButton.refreshButtons(); 
	`
}

export const klarnaRefreshPlacement = () => {
	return `
	window.Klarna && window.Klarna.OnsiteMessaging && window.Klarna.OnsiteMessaging.refresh && window.Klarna.OnsiteMessaging.refresh();
	`
}

export const loadHeaderUSP = `
			var headerUSP = document.querySelector('.header-usps');
			if(headerUSP){
				var headeUSPBlocks = [...document.getElementsByClassName('usp-block')];
				headeUSPBlocks.forEach((uspBlock)=>{
					uspBlock.classList.add("header-usp-hide-mobile");
				})
				headerUSP.classList.remove("hide-mobile");
				var currentUsp = 0;
				hideShowHeaderUSP()
				if(hideShowHeaderUSPIntervalId)clearInterval(hideShowHeaderUSPIntervalId);
				var hideShowHeaderUSPIntervalId = setInterval(hideShowHeaderUSP,3000);
				function hideShowHeaderUSP(){
					headeUSPBlocks[currentUsp].classList.add("header-usp-hide-mobile");
					currentUsp++;
					if(currentUsp===headeUSPBlocks.length){
						currentUsp=0;
					}
					headeUSPBlocks[currentUsp].classList.remove("header-usp-hide-mobile");
				}
			} `;